module.exports = __webpack_public_path__ + "static/media/transparent-logo.6887ffbf.png";